module.exports = __webpack_public_path__ + "img/logo.dd58be73.png";